export const reducerTypes = {
    GET_ALL_SERVICEORDERS: "reducer/GET_ALL_SERVICEORDERS",
    GET_MORE_SERVICEORDERS: "reducer/GET_MORE_SERVICEORDERS",
    SET_PAGE_INFO: "reducer/SET_PAGE_INFO",
    SET_PAGE_INDEX: "reducer/SET_PAGE_INDEX",
    SET_PAGE_SIZE: "reducer/SET_PAGE_SIZE",
    GET_SERVICEORDER: "reducer/GET_SERVICEORDER",
    IS_LOADING: "reducer/LOADING_TRUE",
  };
  
  export const sagaTypes = {
    GET_ALL_SERVICEORDERS: "saga/GET_ALL_SERVICEORDERS",
    GET_MORE_SERVICEORDERS: "saga/GET_MORE_SERVICEORDERS",
    GET_SERVICEORDER: "saga/GET_SERVICEORDER",
  };
  